var layerTypes = {
    'fill': ['fill-opacity'],
    'line': ['line-opacity'],
    'circle': ['circle-opacity', 'circle-stroke-opacity'],
    'symbol': ['icon-opacity', 'text-opacity'],
    'raster': ['raster-opacity'],
    'fill-extrusion': ['fill-extrusion-opacity'],
    'heatmap': ['heatmap-opacity']
};



export function getLayerPaintType(map, layerId) {
    const layer = map.getLayer(layerId);
    if (!layer) {
        console.warn(`Layer "${layer}" not found.`);
        return null;
    }
    return layerTypes[layer.type];
}


export function setLayerOpacity(map, layerConfig) {
    const paintProps = getLayerPaintType(map, layerConfig.layer);
    if (!paintProps) return;

    const visibility = layerConfig.opacity > 0 ? 'visible' : 'none';
    
    setTimeout(() => {
        map.setLayoutProperty(layerConfig.layer, 'visibility', visibility);
    }, layerConfig?.duration || 0);

    paintProps.forEach(prop => {
        const options = layerConfig.duration ? { duration: layerConfig.duration } : {};
        const transitionProp = `${prop}-transition`;
        if (layerConfig.duration) {
            map.setPaintProperty(layerConfig.layer, transitionProp, options);
        }
        map.setPaintProperty(layerConfig.layer, prop, layerConfig.opacity, options);
    });
}
